import React from 'react';
import { formatNumber } from '../../../../utils/formattingUtils';
import styles from '../../../../styles/usageRights.module.css';

interface MiniStatProps {
  icon: React.ReactNode;
  stat: number | null;
}

function MiniStat({ icon, stat }: MiniStatProps) {
  return (
    <div className={styles.miniStat}>
      {icon} {stat ? formatNumber(stat) : 'N/A'}
    </div>
  );
}

export default MiniStat;
